export function nextVariable(text, style = 'numbered', maxVariables = Infinity) {
  const keys = [...String(text || '').matchAll(/\{\{\s*([a-zA-Z_][a-zA-Z_0-9]*|\d+)\s*\}\}/g)].map(match => match[1]);
  if (new Set(keys).size >= maxVariables) return null;
  if (style === 'named') {
    let number = 1;
    while (keys.includes(`variable_${number}`)) number += 1;
    return `{{variable_${number}}}`;
  }
  const numbers = keys.filter(key => /^\d+$/.test(key)).map(Number);
  return `{{${Math.max(0, ...numbers) + 1}}}`;
}

export function insertTemplateVariable(text, start, end, options = {}) {
  const value = String(text || '');
  const token = nextVariable(value, options.style, options.maxVariables);
  if (!token) return null;
  const from = Math.max(0, Math.min(value.length, Number.isInteger(start) ? start : value.length));
  const to = Math.max(from, Math.min(value.length, Number.isInteger(end) ? end : from));
  const before = value.slice(0, from);
  const after = value.slice(to);
  const prefix = options.url
    ? (from === value.length && before && !before.endsWith('/') ? '/' : '')
    : (before && /[\p{L}\p{N}]$/u.test(before) ? ' ' : '');
  const suffix = options.url ? '' : (after && /^[\p{L}\p{N}]/u.test(after) ? ' ' : '');
  const insertion = `${prefix}${token}${suffix}`;
  return { text: `${before}${insertion}${after}`, caret: before.length + insertion.length, token };
}
